import defaultImageLeft from '../../../images/cobranding/default/default_left.svg';
import defaultImageRight from '../../../images/cobranding/default/default_right.svg';
import { HomeLogo } from '@atlaskit/logo';
import { backgroundWithSideImages, CobrandingComponents } from '../shared-cobranding';

export const AtlasBackground = backgroundWithSideImages(defaultImageLeft, defaultImageRight);

const AtlasCobranding: CobrandingComponents = {
  background: AtlasBackground,
  logo: { component: HomeLogo },
  footerProducts: 'Trello, Jira, Confluence',
};

export default AtlasCobranding;
